export default "__VITE_ASSET__2cc3c621__"